import React from 'react';
import { CalendarDays, PhoneCall } from 'lucide-react';

const CallToAction = () => {
  // Br and colors tailored for the white theme
  const brandColors = {
    bgWhite: "#FFFFFF",
    blackPrimary: "#1A1A1A",
    textGray: "#4A4A4A",
    crimson: "#A10F1A",
    gold: "#C79A3B",
  };

  return (
    <section className="py-20 px-6 md:px-12 bg-white flex justify-center">
      <div className="max-w-5xl w-full relative group">
        
        {/* Animated Background Glow (Subtle) */}
        <div className="absolute -inset-1 bg-gradient-to-r from-[#A10F1A] to-[#C79A3B] rounded-2xl blur opacity-20 group-hover:opacity-30 transition duration-1000"></div>

        {/* CTA Container */}
        <div 
          className="relative bg-white rounded-2xl p-10 md:p-16 flex flex-col md:flex-row items-center justify-between gap-10 shadow-2xl overflow-hidden"
          style={{ border: "1px solid rgba(26,26,26,0.08)" }}
        >
          {/* Decorative Top Border */}
          <div 
            className="absolute top-0 left-0 w-full h-[4px]"
            style={{ background: `linear-gradient(90deg, ${brandColors.crimson}, ${brandColors.gold})` }}
          />

          {/* Background Watermark Icon */}
          <div className="absolute -right-10 -bottom-10 opacity-[0.03] pointer-events-none select-none">
            <svg width="300" height="300" viewBox="0 0 24 24" fill="currentColor" style={{ color: brandColors.blackPrimary }}>
              <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
            </svg>
          </div>

          {/* Left Side: Text Content */}
          <div className="flex-1 text-center md:text-left z-10">
            <div className="flex items-center justify-center md:justify-start gap-3 mb-4">
              <span style={{ width: "30px", height: "1px", background: brandColors.crimson }} />
              <span
                style={{
                  fontFamily: "'Cinzel', serif",
                  fontSize: "12px",
                  letterSpacing: "0.2em",
                  color: brandColors.crimson,
                  textTransform: "uppercase",
                  fontWeight: 700,
                }}
              >
                Take The Right Step
              </span>
            </div>
            
            <h2 
              className="text-3xl md:text-5xl font-bold uppercase tracking-wide leading-tight mb-5"
              style={{ fontFamily: "'Cinzel', serif", color: brandColors.blackPrimary }}
            >
              Need Expert <span style={{ color: brandColors.gold }}>Legal</span> Advice?
            </h2>
            
            <p 
              className="text-lg md:text-xl max-w-2xl font-medium leading-relaxed"
              style={{ fontFamily: "'Cormorant Garamond', serif", color: brandColors.textGray }}
            >
              Protect your rights  and interests with R & P  Law Partners. Schedule a consultation today to discuss your case with our experienced legal professionals.
            </p>
          </div>

          {/* Right Side: Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 w-full md:w-auto z-10">
            {/* Primary Button */}
            <a 
              href="contact-us"
              className="flex items-center justify-center gap-3 px-8 py-4 rounded-sm transition-all duration-300 transform hover:-translate-y-1 hover:shadow-lg group"
              style={{ 
                backgroundColor: brandColors.crimson, 
                color: brandColors.bgWhite 
              }}
            >
              <CalendarDays size={18} className="group-hover:scale-110 transition-transform" />
              <span 
                style={{ fontFamily: "'Cinzel', serif", fontWeight: 600, letterSpacing: "0.1em" }}
                className="text-sm uppercase"
              >
                Book Consultation
              </span>
            </a>

            {/* Secondary Button */}
            <a 
              href="tel:+919661900233"
              className="flex items-center justify-center gap-3 px-8 py-4 rounded-sm transition-all duration-300 transform hover:-translate-y-1 hover:shadow-lg group bg-white"
              style={{ 
                border: `2px solid ${brandColors.gold}`,
                color: brandColors.blackPrimary 
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = brandColors.gold;
                e.currentTarget.style.color = brandColors.bgWhite;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = brandColors.bgWhite;
                e.currentTarget.style.color = brandColors.blackPrimary;
              }}
            >
              <PhoneCall size={18} className="group-hover:scale-110 transition-transform" />
              <span 
                style={{ fontFamily: "'Cinzel', serif", fontWeight: 700, letterSpacing: "0.1em" }}
                className="text-sm uppercase"
              >
                Call Us Now
              </span>
            </a>
          </div>

        </div>
      </div>
    </section>
  );
};

export default CallToAction;